import {
  AboutUsPage,
  FuelPumpCatalogPage,
  FuelPumpInfoPage
} from '../../constants/url';

export const AboutAutobestLinkOptions = [
  { name: 'About us', url: AboutUsPage.Home },
  { name: 'Certification', url: AboutUsPage.Certification },
  { name: 'OEM Supplier', url: AboutUsPage.OemSupplier },
  { name: 'Warranty', url: AboutUsPage.Warranty }
];

export const CatalogLinkOptions = [
  { name: 'Fuel Pump Catalog', url: FuelPumpCatalogPage.Home }
];

export const FuelPumpInfoLinkOptions1 = [
  {
    name: 'Electric Fuel Pumps',
    url: FuelPumpInfoPage.Electric
  },
  {
    name: 'Mechanical Fuel Pumps',
    url: FuelPumpInfoPage.Mechanical
  },
  {
    name: 'Direct Injection Fuel Pumps',
    url: FuelPumpInfoPage.DirectInjection
  },
  {
    name: 'Super Duty Fuel Pumps',
    url: FuelPumpInfoPage.SuperDuty
  }
];

export const FuelPumpInfoLinkOptions2 = [
  {
    name: 'High-Performance Fuel Pumps',
    url: FuelPumpInfoPage.HighPerformance
  }
];

export const FuelPumpInfoLinkOptions3 = [
  {
    name: 'Universal Fuel Transfer Pumps',
    url: FuelPumpInfoPage.UniversalTransfer
  },
  {
    name: 'Universal Automotive Fuel Pumps',
    url: FuelPumpInfoPage.UniversalAutomotive
  }
];

export const FuelPumpInfoLinkOptions4 = [
  {
    name: 'Downloads',
    url: FuelPumpInfoPage.Downloads
  }
];

export const FuelPumpsBarItemTextList = [
  'Electric Fuel Pumps',
  'Mechanical Fuel Pumps',
  'Direct Injection Fuel Pumps',
  'Super Duty Fuel Pumps'
];

export const PerformancePumpsBarItemTextList = ['High-Performance Fuel Pumps'];

export const UniversalPumpsBarItemTextList = [
  'Universal Fuel Transfer Pumps',
  'Universal Automotive Fuel Pumps'
];
